export default "__VITE_ASSET__DA4NEJ7i__"